module.exports = __webpack_public_path__ + "static/media/lueddins.b718eb75.png";